import React from 'react';
import { Progress } from 'antd';

interface UploadProgressDisplayProps {
	progress: number;
	label?: string;
}

const UploadProgressDisplay: React.FC<UploadProgressDisplayProps> = ({
	progress,
	label = 'Uploading voice note...',
}) => {
	return (
		<div className="flex items-center gap-3 py-2">
			<Progress type="circle" percent={progress || 0} width={30} />
			<span className="text-sm text-character-secondary">{label}</span>
		</div>
	);
};

export default UploadProgressDisplay;
